export default __webpack_public_path__ + "static/media/ps-car-2.ab163427.jpg";